'use strict';

import React from 'react';
import SectionHeader from 'components/clarity-ui/components/sectionHeader';
import BoxResults from './boxResults/boxResults.component';
import TextResultsTable from './textResults/textResultsTable.component';
import VideoResults from './videoResults/videoResults.component';

class TargetResultsComponent extends React.Component {

  renderTextResults (textDetectorResults) {
    return (
      <div>
        <SectionHeader>
          Text Detector Results
        </SectionHeader>
        <div className="BreakLine">
          <TextResultsTable
            textDetectorResults={textDetectorResults}/>
        </div>
      </div>
    );
  }

  renderBoxResults (boxDetectorResults) {
    return (
      <div>
        <SectionHeader>
          Box Detector Results
        </SectionHeader>
        <div className="BreakLine">
          <BoxResults
            boxDetectorResults={boxDetectorResults}/>
        </div>
      </div>
    );
  }

  renderVideoResults (videoDetectorResults, handleThumbnailOnClick, handleSliderOnChange) {
    return (
      <div>
        <SectionHeader>
          Video Detector Results
        </SectionHeader>
        <div className="BreakLine">
          <VideoResults
            videoDetectorResults={videoDetectorResults}
            handleThumbnailOnClick={handleThumbnailOnClick}
            handleSliderOnChange={handleSliderOnChange}/>
        </div>
      </div>
    );
  }

  render () {
    const { textDetectorResults, boxDetectorResults, videoDetectorResults, handleThumbnailOnClick, handleSliderOnChange } = this.props;
    const isViewEmpty = textDetectorResults.length === 0 && Object.keys(boxDetectorResults).length === 0 && videoDetectorResults.length === 0;

    return (
      <div>
        { textDetectorResults.length > 0 ?
          this.renderTextResults(textDetectorResults) :
          null
        }
        { Object.keys(boxDetectorResults).length > 0 ? this.renderBoxResults(boxDetectorResults) : null }
        { videoDetectorResults.length > 0 ? this.renderVideoResults(videoDetectorResults, handleThumbnailOnClick, handleSliderOnChange) : null }
        { isViewEmpty ? 'No Detector Results Data Available' : null}
      </div>
    );
  }
}

export default TargetResultsComponent;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/targetResults/targetResults.component.jsx